import "./style.less";

export default function GlobalStripe() {
	return <div className="globalStripe">
	</div>;
}
